import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class InvoiceService {
  async fetch(page, perPage, search) {
    const param = search ? `search=${search}` : `page=${page}&perPage=${perPage}`
    const response = await ajaxService.get(`/invoices?${param}`);
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async viewInvoice(id) {
    const response = await ajaxService.get(`/invoices/${id}`);
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async getInvoiceCharges(id) {
    const response = await ajaxService.get(`/invoices/charges/${id}`);
    if (response ?? false) {
      return response;
    }
  }
  async approveInvoice(id) {
    const response = await ajaxService.get(`/invoices/approve/${id}`);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }

  async makePayment(data) {
    const response = await ajaxService.post(
      `/accounts/create-transaction`,
      data
    );
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async generateInvoice(data) {
    const response = await ajaxService.post(`/invoices/charges`, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async updateInvoice(id, data) {
    const response = await ajaxService.put(`/invoices/`, id, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }

  async sendEmail(data) {
    const response = await ajaxService.post(`/invoices/send-email`, data)
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors)
    }
  }

  /* Customer Invoice API */
  async fetchCustomerInvoices(page, pageSize, search) {
    const param = search ? `search=${search}` : `page=${page}&perPage=${pageSize}`
    const response = await ajaxService.get(`/client-invoices?${param}`);
    if (response?.success ?? false) {
      return response;
    }
    else {
      const errors = response.data.errors;
      return validationErrors(errors)
    }
  }

  async fetchCustomerInvoicesData(id) {
    const response = await ajaxService.get(`/customers/invoices/${id}`);
    if (response?.success ?? false) {
      return response;
    }
    else {
      const errors = response.data.errors;
      return validationErrors(errors)
    }
  }


  async viewCustomerInvoice(id) {
    const response = await ajaxService.get(`/client-invoices/${id}`);
    if (response ?? false) {
      return response;
    }
  }

  async logs(id, page, pageSize,) {
    const param = `page=${page}&perPage=${pageSize}`
    const response = await ajaxService.get(`/invoices/${id}/logs?${param}`);
    if (response?.success ?? false) {
      return response;
    }
    else {
      const errors = response.data.errors;
      return validationErrors(errors)
    }
  }
}

const invoiceService = new InvoiceService();

export default invoiceService;
